/**
 * @fileoverview Excel関連操作をまとめたドロップダウンメニュー
 * @description 出力・フォーマットDL・取込などを1つの「Excel」ボタンに集約する。
 */
import React, { useState } from 'react';
import { FileSpreadsheet, ChevronDown } from 'lucide-react';

export interface ExcelMenuItem {
  icon: React.ReactNode;
  label: string;
  desc?: string;
  onClick: () => void;
}

const ExcelMenu: React.FC<{ items: ExcelMenuItem[] }> = ({ items }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <button onClick={() => setOpen(v => !v)}
        style={{
          padding: '8px 14px', borderRadius: 10, border: '1.5px solid #BFD7EC', background: open ? '#D8EAF8' : '#EAF3FB',
          color: '#0E5AA7', fontSize: 12.5, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
        }}>
        <FileSpreadsheet size={14} />Excel<ChevronDown size={13} style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }} />
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 180 }} />
          <div style={{
            position: 'absolute', top: 'calc(100% + 6px)', right: 0, zIndex: 190,
            background: 'white', borderRadius: 12, border: '1px solid #E3E9EF',
            boxShadow: '0 10px 32px rgba(22,40,59,0.18)', minWidth: 300, padding: 6,
          }}>
            {items.map((it, i) => (
              <button key={i} onClick={() => { setOpen(false); it.onClick(); }}
                onMouseEnter={e => (e.currentTarget.style.background = '#F2F7FC')}
                onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
                style={{
                  display: 'flex', alignItems: 'flex-start', gap: 10, width: '100%', textAlign: 'left',
                  border: 'none', background: 'transparent', borderRadius: 8, padding: '10px 12px', cursor: 'pointer',
                }}>
                <span style={{ color: '#0E5AA7', marginTop: 1 }}>{it.icon}</span>
                <span>
                  <span style={{ display: 'block', fontSize: 13, fontWeight: 700, color: '#16283B' }}>{it.label}</span>
                  {it.desc && <span style={{ display: 'block', fontSize: 11, color: '#8395A7', marginTop: 2 }}>{it.desc}</span>}
                </span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ExcelMenu;
